/* Project specific Javascript goes here. */
import '../sass/project.scss';
import { initSortableTable } from './sortable-table';
import { initPickHighlighting } from './pick-highlighting';

window.initSortableTable = initSortableTable;

document.addEventListener('DOMContentLoaded', initPickHighlighting);
